// Section (Patterns; was primitives.tsx's, HIERARCHY follow-up 9, BL-189): a ruled section of a page
// (DESIGN.md §3a): a rule above, its name under it with its count, muted, beside it, then what's in it.
// Never a box. One after another they keep a gap; the first in its column takes none. Area is the one
// that folds; a Section never does. It keeps base.css's classes (.flw-sec), which page sheets place by.
// Where what it holds stands (BL-189, a sales tax return's Not filed) is StateMark and its word at the
// end of the name's line: in ink while it waits, muted once settled.
import type { ReactNode } from 'react';
import { StateMark, type MarkState } from '../../components/StateMark/StateMark.tsx';
import './Section.css';

export interface SectionProps {
  /** Its name, under the rule ("Company holidays"); its name for screen readers too. */
  title: string;
  /** How many there are, beside the name. */
  count?: number;
  /** Where it stands, at the end of the name's line: StateMark's mark and its word ("Not filed"). */
  state?: { mark: MarkState; word: string };
  children?: ReactNode;
}

export function Section({ title, count, state, children }: SectionProps) {
  return (
    <section className="flw-sec" aria-label={title}>
      <h2>
        {title}
        {count != null && <span className="flw-cnt">{count}</span>}
        {state && (
          <span className="flw-sec__state" data-state={state.mark}>
            <StateMark state={state.mark} />
            <span className="flw-sec__word">{state.word}</span>
          </span>
        )}
      </h2>
      {children}
    </section>
  );
}
